export default {
  close: require('./close/close.svg'),
  point: require('./point/point.svg'),
  pinkPlus: require('./plusPink/copy.svg'),
};
